import React from 'react';
import './services.css';
import { Card, CardBody, CardTitle, CardText } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faFemale, 
    faBirthdayCake, 
    faHeart, 
    faRing,
    faCamera,
    faGlassCheers,
    faBaby,
    faMosque,
    faGraduationCap
} from '@fortawesome/free-solid-svg-icons';

const Services = () => {
    return (
        <div className="services-container">
            <h2 >Our Services</h2>
            <div className="services-cards">
                <ServiceCard
                    title="Bridal Shoots"
                    description="Elegantly capture the beauty and grace of the bride with our dedicated bridal photography sessions."
                    icon={faFemale}
                />
                <ServiceCard
                    title="Birthday Shoots"
                    description="Celebrate your loved ones' milestones with memorable birthday photography sessions."
                    icon={faBirthdayCake}
                />
                <ServiceCard
                    title="Anniversary Shoots"
                    description="Commence the next chapter of your love story with beautiful anniversary photography sessions."
                    icon={faHeart}
                />
                <ServiceCard
                    title="Engagement Shoots"
                    description="Announce your engagement with style through our romantic engagement photography sessions."
                    icon={faRing}
                />
                <ServiceCard
                    title="Pre-Wedding Shoots"
                    description="Capture the excitement and anticipation leading up to your big day with our pre-wedding photography sessions."
                    icon={faCamera}
                />
                <ServiceCard
                    title="Dholki Shoots"
                    description="Immerse yourself in the joyous celebration of dholki ceremonies with our vibrant dholki photography services."
                    icon={faGlassCheers}
                />
                <ServiceCard
                    title="Baby Bump Shoots"
                    description="Celebrate the miracle of pregnancy and the anticipation of new life with our intimate maternity photography sessions."
                    icon={faBaby}
                />
                <ServiceCard
                    title="Nikkah Shoots"
                    description="Honor the sacred union of marriage with our traditional and heartfelt Nikkah photography services."
                    icon={faMosque}
                />
                <ServiceCard
                    title="Mayyun Shoots"
                    description="Mark the joyful pre-wedding festivities with our lively and colorful Mayyun photography sessions."
                    icon={faGlassCheers}
                />
            </div>
        </div>
    );
};

const ServiceCard = ({ title, description, icon }) => {
    return (
        <Card className="service-card">
        
            <div className="icon-container">
                <FontAwesomeIcon icon={icon} className="service-icon" />
            </div>
            <CardBody>
                <CardTitle tag="h3" className="service-title">{title}</CardTitle>
                <CardText className="service-description">{description}</CardText>
            </CardBody>
        </Card>
    );
};

export default Services;
